
import BillingInfo from '@/components/view/common/billing-info';
import { PropType, ref, defineComponent } from 'vue';
import { autoPayCancleReasonMap } from '@/constant/field-map';
import {
    getInfoSubscription,
    GetInfoSubscription,
    cancelSubscription,
    delSubscription,
    GetListForInsSubscription
} from '@/api/office/subscription';
import { saveTableSortStatus, getDefaultSort, setTableSortByFrontEnd } from '@/util/table';

import PanelList from '@/components/common/panel-list';
import { ElMessageBox } from 'element-plus';

export default defineComponent({
    components: {
        PanelList,
        BillingInfo
    },
    props: {
        lastStep: {
            type: String,
            default: '',
            require: true
        },
        userType: {
            type: String,
            default: '',
            require: true
        },
        isBatch: {
            type: Boolean,
            default: false,
            require: true
        },
        isBatchForAutoRenew: {
            type: String,
            require: true
        },
        data: {
            type: Object as PropType<GetListForInsSubscription['row'][0]>,
            default: () => ({}),
            require: true
        }
    },
    setup(props, { emit }) {
        function back() {
            emit('changeStep', { type: 'back', to: props.lastStep });
        }
        const autoPayInfo = ref<GetInfoSubscription>({
            ID: 0,
            OrderNumber: '',
            Status: -1,
            TotalPrice: '',
            StartTime: '',
            EndTime: '',
            NextPayTime: '',
            CreateTime: '',
            IntervalType: 0,
            Cycles: 0,
            PayPlatform: 0,
            UUID: '',
            TimeZone: '',
            Reason: -1,
            Items: []
        });
        const intervalTypeMap = {
            0: WordList.ProperAllTextMonthly,
            1: WordList.Quarterly,
            2: WordList.Yearly
        };
        const intervalTypeMapTitle = {
            0: WordList.TotalPriceByMonth,
            1: WordList.TotalPriceByQuarter,
            2: WordList.TotalPriceByYear
        };
        const panelListColumn = [
            { prop: 'IntervalType', label: WordList.RenewType },
            // { prop: 'StartTime', label: WordList.TmpKeyManageListTanleBeginTime },
            { prop: 'Cycles', label: WordList.RenewTimes },
            { prop: 'NextPayTime', label: WordList.NextApproximatePaydate },
            { prop: 'number', label: WordList.NumberOfRenewalUser },
            { prop: 'TotalPrice', label: WordList.TotalPriceByMonth }
        ];

        const column = [
            { prop: 'DepartmentName', label: WordList.ProperAllTextDepartment },
            { prop: 'Email', label: WordList.TabelPropertyManageEmail },
            { prop: 'Name', label: WordList.TabelPersonUserInHtmlName },
            { prop: 'Amount', label: `${WordList.ProperAllTextPackageFee}($)` },
            { prop: 'ExpireTime', label: WordList.TabelExpretimeBoxSpecificTime }
        ];

        // 获取订阅详情
        getInfoSubscriptionApi();
        function getInfoSubscriptionApi() {
            const params = { UUID: props.data.UUID };
            // if(props.userType === 'distributorCommunity'){
            //     params.IsBatch = props.isBatch ? 1 : 0;
            // }
            getInfoSubscription(params, (res: GetInfoSubscription) => {
                autoPayInfo.value = res;
            });
        }

        function editAutoPay() {
            emit('changeStep', { type: 'forward', to: 'process-1', data: autoPayInfo.value });
        }
        function cancelPlan() {
            ElMessageBox.confirm(
                WordList.CancelAutomaticPaymentsTips,
                WordList.TabelDeleteTitle,
                {
                    confirmButtonText: WordList.TabelFootSure,
                    cancelButtonText: WordList.TabelFootCancel,
                    type: 'warning'
                }
            ).then(() => {
                cancelSubscription({ UUID: props.data.UUID }, () => {
                    emit('changeStep', { type: 'back', to: props.lastStep });
                });
            });
        }
        function delAutoPayRecord() {
            ElMessageBox.confirm(
                WordList.ProperAllTextDeleteTip,
                WordList.TabelDeleteTitle,
                {
                    confirmButtonText: WordList.TabelFootSure,
                    cancelButtonText: WordList.TabelFootCancel,
                    type: 'warning'
                }
            ).then(async () => {
                delSubscription({ UUID: props.data.UUID }, () => {
                    emit('changeStep', { type: 'back', to: props.lastStep });
                });
            });
        }
        // 排序初始化：默认表格排序
        const tableName = 'autoPayInfoTableForCommunityIndis';
        const defaultTableSort = getDefaultSort(tableName);
        // 排序变化
        function tableSortChange({ column, prop, order }: Record<string, string>) {
            const { SortField, Sort } = saveTableSortStatus(tableName, prop, order);
            autoPayInfo.value.Items = setTableSortByFrontEnd(autoPayInfo.value.Items, { SortField, Sort });
        }

        return {
            back,
            autoPayInfo,
            intervalTypeMap,
            intervalTypeMapTitle,
            panelListColumn,
            column,
            getInfoSubscriptionApi,
            editAutoPay,
            cancelPlan,
            delAutoPayRecord,
            defaultTableSort,
            tableSortChange,
            autoPayCancleReasonMap
        };
    }
});

